module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#share",
      toString: function () {
        return this.url;
      }
    }